export default String.raw`
$(document).ready(()=>{
    const numberOfSlides = $(".infographicBanner__swiper").find(".infographicBanner__wrapper").data("len");
    const timer = $(".infographicBanner").data("timer");
    let isAutoplay = false;

    if (typeof(timer) === "number" && timer >= 0) {
        isAutoplay = true;
    }

    let autoplayConfig = false;
    if (isAutoplay) {
        autoplayConfig = { delay: timer };
    }

    const swiper = new Swiper(".infographicBanner__swiper", {
        navigation: {
            nextEl: '.infographicBanner__next',
            prevEl: '.infographicBanner__prev',
        },
        centerInsufficientSlides: true,
        autoplay: autoplayConfig,
        breakpoints: {
            0: {
                slidesPerView: 1.5,
                spaceBetween: 16,
                loop: (numberOfSlides > 2)
            },

            769: {
                slidesPerView: 2.5,
                spaceBetween: 24,
                loop: (numberOfSlides > 3)
            },

            1440: {
                slidesPerView: 5,
                spaceBetween: 24,
                loop: (numberOfSlides > 5)
            }
        },
        a11y: false,
        keyboard: {
            enabled: true,
            pageUpDown: true
        },
        pause: {
            enabled: true,
            el: '.infographicBanner-pause-button',
        },
        watchSlidesProgress: true,
        on: {
            init: function () {
                app.manageTabIndexInsideSlide(this);
            },
            slideChangeTransitionEnd: function () {
                app.manageTabIndexInsideSlide(this);
            }
        },
    });

    if (swiper.params.loop && isAutoplay) {
        swiper.autoplay.start();
    } else {
        swiper.autoplay.stop();
    }

    swiper.on("breakpoint", () => {
        if (swiper.params.loop && isAutoplay) {
            swiper.autoplay.start();
        } else {
            swiper.autoplay.stop();
        }
    })
});
`